import { ApplicationStatusId } from "@ploy-lib/types";
import { BaseCamelCasedResource } from "./BasePlainResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
class RecentApplicationResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.applicationNumber = "";
        this.customerName = "";
        this.productName = "";
        this.category = "";
        this.status = "";
        this.statusId = ApplicationStatusId.NotSet;
        this.documentStatus = "";
        this.lastChanged = new Date().toISOString();
    }
    pk() {
        return this.applicationNumber;
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            dataExpiryLength: 500,
            pollFrequency: 5000
        };
    }
}
RecentApplicationResource.urlRoot = legacyApiResourceUrl("RecentApplications/GetRecentApplications");
export { RecentApplicationResource };
//# sourceMappingURL=RecentApplicationResource.js.map